import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventosService {
  storage = null;
  accessToken = '';
  headers = {};
  constructor(private http: HttpClient) {
    this.storage = localStorage.getItem('at');

    if (this.storage) {
      const decode = atob(this.storage);
      this.accessToken = JSON.parse(decode);
    }

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }

  disableEvents(): Observable<any> {
    let body = {
      request_data: {
        type_action: 'disable_events',
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/marketplaces`, body);
  }

  addEvent(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'add',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/eventos`, body);
  }

  getEvents(id_empresa_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_all',
        data: { id_empresa_usuario: id_empresa_usuario },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/eventos`, body);
  }

  verifyEvent(id_evento: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'verify_event',
        id_evento: id_evento,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/marketplaces`, body);
  }
}
